var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "appointment-hours" },
    _vm._l(_vm.availableHours, function (hour) {
      return _c(
        "div",
        {
          staticClass: "appointment-hour",
          class: { "is-selected": _vm.selectedHour === hour.from },
          on: {
            click: function ($event) {
              return _vm.handleClickHour(hour.from)
            },
          },
        },
        [_c("p", [_vm._v(_vm._s(hour.text))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }